import React from "react";
import { matchesString } from "LIB/filters";
import { Search } from "MODULES/shared/components";
import {
  FilterSelect,
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import {
  QC_HOLD,
  QC_STATUS,
  UNDER_REVIEW
} from "MODULES/inventories/constants";
import { properCase } from "LIB/formatters/text";
import { CLEAR_FILTERS_TEXT } from "APP_ROOT/constants";
import Table from "./Table";
import { reservedForRepairInventory } from "../../pagination";

const filters = [
  {
    label: "Show QC Hold",
    filters: { qc_status: "qc_hold" }
  },
  {
    label: "Show QC Under Review",
    filters: { qc_status: "under_review" }
  },
  {
    label: "Show Discrepancy Reported",
    filters: { open_discrepancies: true }
  },
  {
    label: CLEAR_FILTERS_TEXT,
    filters: {
      qc_status: undefined,
      open_discrepancies: undefined
    }
  }
];

const filterTags = [
  {
    label: properCase(UNDER_REVIEW),
    key: QC_STATUS,
    matchesTarget: matchesString(UNDER_REVIEW)
  },
  {
    label: "QC Hold",
    key: QC_STATUS,
    matchesTarget: matchesString(QC_HOLD)
  },
  {
    label: "Discrepancies Reported",
    key: "open_discrepancies"
  }
];

export default function RepairOrderSearch() {
  return (
    <Search search={reservedForRepairInventory} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a part number or serial number..."
              />
              <FilterSelect {...searchProps} filters={filters} right />
            </div>
          </div>
          <TitleWithFilters
            {...searchProps}
            title="Reserved For Repair"
            filters={filterTags}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/ReserveForRepair/Search.jsx